import { el } from "../utils/dom";
import { entraLoginUrl } from "../services/auth";

export function renderEntraSignIn(message?: string): HTMLElement {
  return el("div", { className: "adminkey-gate" }, [
    el("div", { className: "adminkey-gate__panel panel panel--dominant" }, [
      el("p", { className: "panel__title" }, ["Sign in"]),
      el("p", { className: "panel__description" }, [
        message || "Use your Microsoft work account to open this console.",
      ]),
      el(
        "a",
        {
          className: "btn btn-primary",
          href: entraLoginUrl(),
        },
        ["Sign in with Microsoft"]
      ),
    ]),
  ]);
}

export function renderAccessPending(status: "pending" | "rejected", email: string | null, onSignOut: () => void): HTMLElement {
  const pending = status === "pending";
  return el("div", { className: "adminkey-gate" }, [
    el("div", { className: "adminkey-gate__panel panel panel--dominant" }, [
      el("p", { className: "panel__title" }, [pending ? "Access requested" : "Access denied"]),
      el("p", { className: "panel__description" }, [
        pending
          ? `Signed in as ${email || "your Microsoft account"}. An approved admin needs to grant access before you can use this console.`
          : `Signed in as ${email || "your Microsoft account"}. This account was not approved for admin access.`,
      ]),
      el(
        "button",
        { className: "btn btn-ghost", type: "button", onclick: () => onSignOut() },
        ["Sign out"]
      ),
    ]),
  ]);
}
